module.exports = __webpack_public_path__ + "img/4.7c19b58b.webp";